import {
  format,
  formatDistanceToNow,
  isThisYear,
  isToday,
  parseISO,
} from "date-fns"

export function formatDate(date: string) {
  const parsedDate = parseISO(date)

  if (isToday(parsedDate)) {
    return formatDistanceToNow(parsedDate, { addSuffix: true })
  }

  if (isThisYear(parsedDate)) {
    return format(parsedDate, "MMM d")
  }

  return format(parsedDate, "MMM d, yyyy")
}
